module.exports = __webpack_public_path__ + "static/img/importing.fdc0f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/importing.png
// module id = NSy6
// module chunks = 0